/**
 * Functions used internally by UMM to support
 * @userlike/messenger@1.0.0
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var EVENT_NAME = "userlike:messenger:script";
/**
 * @deprecated
 */
export var notifyScriptLoad = function (payload, target) {
    if (target === void 0) { target = window; }
    target.dispatchEvent(new CustomEvent(EVENT_NAME, {
        detail: payload,
    }));
};
/**
 * @deprecated
 */
export function isPureLoader(widgetKey, global) {
    if (global === void 0) { global = window; }
    return getCustomWindow(global).__USERLIKE_PURE__[widgetKey] === true;
}
function getCustomWindow(window) {
    var customWindow = window;
    customWindow.__USERLIKE_PURE__ = __assign({}, customWindow.__USERLIKE_PURE__);
    return customWindow;
}
